export const transformImmatriculation = (input) => {
    if (input === null) return "N/A";
    const correctFormatRegex = /^[A-Z]{2}\sTG\s\d+$/;
    if (correctFormatRegex.test(input)) return input;

    const initialFormatRegex = /^([A-Z]{2})\s(\d+)\s(TG)$/;
    const match = input.match(initialFormatRegex);
    if (!match) return input;

    const letters = match[1];
    const numbers = match[2];
    const country = match[3];
    return `${letters} ${country} ${numbers}`;
};

export const parseImmatriculation = (immatriculation) => {
    if (!immatriculation || typeof immatriculation !== 'string') {
        return { typeSerie: '', numeroSerie: '', matricule: '' };
    }

    const cleaned = immatriculation.toUpperCase().replace(/\s+/g, '');
    const parts = cleaned.match(/[A-Z]+|\d+/g);
    if (!parts || parts.length < 2) {
        return { typeSerie: '', numeroSerie: '', matricule: '' };
    }

    const numericPart = parts.find(part => /^\d+$/.test(part));
    const letters = parts.filter(part => /^[A-Z]+$/.test(part));

    if (!numericPart || letters.length < 2) {
        const match = cleaned.match(/^([A-Z]{2})(TG)(\d{4})$|^([A-Z]{2})(\d{4})(TG)$|^(TG)(\d{4})([A-Z]{2})$/);
        if (match) {
            const [, ns1, ts1, m1, ns2, m2, ts2, ts3, m3, ns3] = match;
            return {
                typeSerie: ts1 || ts2 || ts3 || 'TG',
                numeroSerie: ns1 || ns2 || ns3 || '',
                matricule: m1 || m2 || m3 || '',
            };
        }
        return { typeSerie: '', numeroSerie: '', matricule: '' };
    }

    const otherLetters = letters.filter(l => l !== 'TG');
    const numeroSerie = otherLetters.length > 0 ? otherLetters[0] : '';
    return { typeSerie: 'TG', numeroSerie, matricule: numericPart };
};

export const formatImmatriculationForProduction = (immatriculation) => {
    if (!immatriculation || typeof immatriculation !== 'string') return '';
    const { typeSerie, numeroSerie, matricule } = parseImmatriculation(immatriculation);
    const segments = [];
    if (typeSerie) segments.push(typeSerie.toUpperCase());
    if (matricule) segments.push(matricule.toUpperCase());
    if (numeroSerie) segments.push(numeroSerie.toUpperCase());
    const formatted = segments.join(' ').trim();
    return formatted || immatriculation.toUpperCase().replace(/\s+/g, ' ').trim();
};

export const composeImmatriculation = (typeSerie, matricule, numeroSerie) => {
    const parts = [typeSerie, matricule, numeroSerie]
        .map(part => (typeof part === 'string' ? part.trim().toUpperCase() : ''))
        .filter(Boolean);
    if (parts.length === 0) return '';
    return parts.join(' ').replace(/\s+/g, ' ').trim();
};

export const splitNameStringForPrintingAttestation = (input, maxChars) => {
    if (typeof input !== "string" || typeof maxChars !== "number" || maxChars <= 0) {
        throw new Error("Invalid input or maximum character limit");
    }
    let firstLine = "";
    let secondLine = "";
    const words = input.split(" ");
    for (let word of words) {
        if ((firstLine + word).length <= maxChars) {
            firstLine += (firstLine ? " " : "") + word;
        } else {
            secondLine += (secondLine ? " " : "") + word;
        }
    }
    return { firstLine, secondLine };
};
